module.exports = __webpack_public_path__ + "static/vimeo-8f0123155fb4a8fafe20deafca6ea0c4.png";